import React from "react";
import { aboutData } from '@data/aboutData';

const Info = () => {
    return (
        <div className="about__info grid">
            <div className="about__box">
                <i className='bx bx-award about__icon'></i>
                <h3 className="about__title">Experience</h3>
                <span className="about__subtitle">{aboutData.experience}</span>
            </div>

            <div className="about__box">
                <i className='bx bx-briefcase-alt about__icon'></i>
                <h3 className="about__title">Completed</h3>
                <span className="about__subtitle">{aboutData.projectCompleted}</span>
            </div>

            <div className="about__box">
                <i className='bx bx-support about__icon'></i>
                <h3 className="about__title">Availability</h3>
                <span className="about__subtitle">{aboutData.supportTime}</span>
            </div>
        </div>
    );
}

export default Info;